<div class="text-center">
  <kendo-badge-container>
    <kendo-badge size="large" rounded="medium" [themeColor]="badgeColor">
      <div [ngStyle]="{ color: textColor }">
        {{ status || "" | translate }}
      </div>
    </kendo-badge>
  </kendo-badge-container>
</div>
